import $ from 'jquery'

class AjaxRequest {
    constructor(options) {
        var _this = this;
        this.elementToAddLoading = null;
        this.requestType = 'post';

        this.errorCallback = function () { };
        this.successCallback = function () { };

        this.beforeSend = function () {
            if (_this.elementToAddLoading !== null) {
                if (typeof _this.elementToAddLoading === "string") {
                    $(_this.elementToAddLoading).addClass("is-loading");
                } else {
                    _this.elementToAddLoading.addClass("is-loading");
                }

            }
        };

        this.complete = function () {
            if (typeof _this.elementToAddLoading === "string") {
                $(_this.elementToAddLoading).removeClass("is-loading");
            } else {
                if (_this.elementToAddLoading !== null) {
                    _this.elementToAddLoading.removeClass("is-loading");
                }
            }
        };

        if (typeof options !== 'undefined') {
            $.extend(_this, options);
        }
    }
    makeCall(url, params, options) {
        var _this = this;

        options = $.extend({
            type: _this.requestType,
            url: url,
            data: params,
            beforeSend: _this.beforeSend,
            complete: _this.complete,
            success: _this.successCallback,
            error: _this.errorCallback
        }, options);

        $.ajax(options);
    }
}

export default AjaxRequest


